<!---Global-loader-->
<!-- <div *ngIf="isSpinnerVisible">
    <div id="global-loader">
        <img src="assets/images/loader.svg" class="loader-img" alt="loader">
    </div>
</div> -->
<!--- End Global-loader-->

<div class="preloader-backdrop" *ngIf="isSpinnerVisible">
  <div class="page-preloader"></div>
</div>